import React, { useEffect, useState, useContext } from 'react';
import { Button, message, Row, Col, Divider, Spin, Space, List, Select, DatePicker, Modal, Form, Avatar, TimePicker, Input, Descriptions, Table,InputNumber } from 'antd';
import AppContext from "../AppContext";
import moment from 'moment';
import { onGetAttendancelist, createAttendance, updateAttendance } from '../../Controller/Attendance';
import { getAllUserLists } from '../../Controller/Management/UserProf_Ctrl';
import { onGetBranch } from '../../Controller/Management/BranchManagement'
import { onGetShift } from '../../Controller/Management/ShiftManagement';
import { ReloadOutlined, PlusOutlined } from "@ant-design/icons";
import T_Error from "../404";

const { Option } = Select;
const { TextArea } = Input;

export default function AttendanceManagement(prop) {
    const global = useContext(AppContext)
    const userid = global.UserIdentity.userid;
    const [btndisable, setBtnDisable] = useState(false);
    const [form] = Form.useForm();
    const [isMaintenance, setIsMaintenance] = useState(false);      // Used for maintenance
    // ===== LIST ======
    const [datasource, setDatasource] = useState([]);
    const [Fulldatasource, setFUllDatasource] = useState([]);
    const [flexibledata, setflexibledata] = useState([]);
    const [userLists, setUserLists] = useState([]);
    const [branchLists, setBranchLists] = useState([]);
    const [initLoading, setInitLoading] = useState(true);
    const [searchUser, setSearchUser] = useState("");
    //===== STATE ======
    const [date, setDate] = useState("");
    const [dateFilter, setDateFilter] = useState("date");
    const [type, setType] = useState("");
    const [currentuser, setcurrentuser] = useState("");
    const [leavetypefilter, setleavetypefilter] = useState(undefined);
    //===== TOTAL USER =========
    const [totaluser, settotaluser] = useState(0);
    const [usertaken, setusertaken] = useState(0);
    const [userleft, setuserleft] = useState(0);
    //======= MODAL ========
    const [isModalVisible, setIsModalVisible] = useState("");
    const [isModalVisible2, setIsModalVisible2] = useState("");
    const [modalTitle, setModalTitle] = useState("");
    const [action, setAction] = useState("");
    //======= LEAVE TYPES ========
    const leavetypes = ["Att", "MC", "AL", "UL", "EL", "HL", "Trip", "Free", "WFH"];
    //===== PERMISSION =========
    const [status, setStatus] = useState("");
    const [showintime, setshowintime] = useState(true);
    const [showbranch, setshowbranch] = useState(true);

    const [shiftlist, setShiftList] = useState([]);

    useEffect(() => {
        return Promise.all([getAllUserLists({}), onGetBranch({}), onGetShift({})])
            .then(([list, list2, list3]) => {
                setUserLists(list.data);
                settotaluser(list.data.length);
                setBranchLists(list2.data);
                setShiftList(list3.data);
                setDate(moment());

            });

    }, [])

    useEffect(() => {
        setDate(moment())
    }, [dateFilter])

    useEffect(() => {
        if (date == "" || date == null) {
            setDatasource([]);
        }
        else {
            //===== LEAVE TYPE FILTER ====
            if (leavetypefilter == undefined) {
                onRefresh({ searchuser: searchUser });
            }
            else {
                onRefresh({ searchuser: searchUser })
                    .then(val => {
                        let tempdata = []
                        tempdata = Fulldatasource
                        let newds = tempdata.filter(x => x.type == leavetypefilter);

                        setDatasource(newds);
                    })
            }
        }
    }, [date, leavetypefilter])

    useEffect(() => {
        let userleft = totaluser - usertaken;
        setuserleft(userleft);
    }, [totaluser, usertaken])

    const convertSecondsToTime = (seconds) => {
        const hours = Math.floor(seconds / 3600);
        const minutes = Math.floor((seconds % 3600) / 60);

        if (hours > 0) {
            return `${hours}h ${minutes}m`;
        }

        return `${minutes}m`;
    };

    var flexibletable = [
        {
            title: 'In',
            dataIndex: 'punchin',
            key: 'punchin',
            render: (text) => {
                return (
                    <div>
                        {moment.unix(text).format('HH:mm:ss')}
                    </div>
                )
            }
        },
        {
            title: 'Out',
            dataIndex: 'punchout',
            key: 'punchout',
            render: (text) => {
                if (text != '') {
                    return (
                        <div>
                            {moment.unix(text).format('HH:mm:ss')}
                        </div>
                    )
                }

                else {
                    return (
                        <div>
                            {text}
                        </div>
                    )
                }

            }
        },
        {
            title: 'Work',
            dataIndex: 'workduration',
            key: 'workduration',
            render: (text) => {
                return (
                    <div>
                        {convertSecondsToTime(text)}
                    </div>
                )
            }
        },
        {
            title: 'Extra',
            dataIndex: 'extra',
            key: 'extra',
            render: (text) => {
                return (
                    <div>
                        {convertSecondsToTime(text)}
                    </div>
                )
            }
        },
        {
            title: 'Action',
            key: 'action',
            render: (text, item) => (
                <Button type="link" onClick={() => {


                    setIsModalVisible2(false)
                    let values = { ...item };
                    let editId = values._id || "";
                    values.date = moment(item.date);
                    values.punchin = typeof item.punchin == "string" ? item.punchin == "" ? "" : moment.unix(item.punchin) : item.punchin;
                    values.punchout = typeof item.punchout == "string" ? item.punchout == "" ? "" : moment.unix(item.punchout) : item.punchout;
                    console.log("item >>>>", item)
                    form.setFieldsValue(values);
                    setType(values.type);

                    // ID IS NOT EXIST MEANS NOT PUNCH CARD

                    if (editId != "") {
                        showModal("edit");
                    }



                }}>Edit</Button>
            ),
        },
    ]



    //===== FUNCTION =====
    const onRefresh = (data) => {
        let { searchuser = '' } = data;
        let newDate;
        switch (dateFilter) {
            case "month":
                newDate = date.format("YYYY/MM");
                break;
            default:
                newDate = date.format("YYYY/MM/DD");
                break;
        }

        //====== TO GET ATTENDANCE LIST ======
        return onGetAttendancelist({
            date: newDate,
            searchuser: searchuser
        })
            .then((val) => {
                console.log("val.data >>>", val.data)
                // if (searchuser == '') {
                //     onGetDatasource(val.data);
                // }
                // else {
                //     setDatasource(val.data);
                // }

                onGetDatasource(val.data)

                setInitLoading(false);
                return val;
            })
            .catch(err => {
                message.error("Cannot get data");
                setIsMaintenance(true);
            });
    }

    //20210906 ON GET DATASOURCE 
    const onGetDatasource = (data) => {
        if (dateFilter == "date") {
            let array = [];

            var count = 0
            console.log("userLists >>>", userLists)
            for (var i = 0; i < userLists.length; i++) {
                let userid = userLists[i]._id;
                let userexist = data.filter(x => x.username == userid);

                if (userexist.length > 0) {
                    userexist[0]["key"] = userLists[i].userid;
                    //userexist[0]["username"] = userLists[i].userid;
                    userexist[0]["details"] = data.filter(x => x.username == userid);

                    const userFilteredData = data.filter(x => x.username == userid);


                    const sumWorkDuration = userFilteredData.length > 0
                        ? userFilteredData.reduce((acc, item) => {
                            acc += item.workduration;
                            return acc;
                        }, 0)
                        : 0;

                    const sumExtra = userFilteredData.length > 0
                        ? userFilteredData.reduce((acc, item) => {
                            acc += item.extra;
                            return acc;
                        }, 0)
                        : 0;

                    const hasEmptyPunchout = userFilteredData.some(item => item.punchout === "" || item.punchout === undefined);

                    var missingpunchout = 0
                    if (hasEmptyPunchout) {
                        missingpunchout = 1
                    }


                    userexist[0]["workdurationperday"] = sumWorkDuration;
                    userexist[0]["extraperday"] = sumExtra;
                    userexist[0]["missingpunchout"] = missingpunchout;
                    array.push(userexist[0]);
                    count++
                }
                else {
                    array.push({
                        username: userLists[i].userid,
                        type: "",
                        date: date,
                        islate: 0,
                        isearly: 0,
                        punchin: "",
                        punchout: "",
                        branchin: "",
                        branchout: "",
                        bipin: "",
                        bipout: "",
                        workduration: 0,
                        extra: 0,
                        workdurationperday: 0,
                        extraperday: 0
                    });
                }
            }
            setFUllDatasource(array)
            setDatasource(array);
            setusertaken(count);

        }
        else {
            setFUllDatasource(data)
            setDatasource(data);

        }
    }

    //20210727 add refresh all windows
    const onReload = () => {
        setBtnDisable(true);
        window.location.reload();
    }

    const onFinish = (data) => {
        console.log("save data >>>>", data)
        let dts = "", currentdts = "", newpunchin = "", newpunchout = "";
        let newAction = action;
        // 20210907 IF EDIT BUT NO RECORDS FOR USER
        let userid = userLists.find(x => x.userid == data.username)?._id
        if (data._id == undefined) {
            newAction = "create";
        }

        if (userid == undefined) {
            userid = currentuser.username
        }

        console.log("userid >>>>", userid)
        console.log("newAction >>>>", newAction)
       
        switch (newAction) {
            case "create":
                //====== CHECK IF THE USER HAD DATA =========
                dts = data.date.set({ "hour": 0, "minute": 0, "seconds": 0 }).unix();
                currentdts = moment().set({ "hour": 0, "minute": 0, "seconds": 0 }).unix();

                // newpunchin      = data.punchin == "" ? ""   : (data?.punchin?.unix() - currentdts) + dts || "";
                // newpunchout     = data.punchout == "" ? ""   : (data?.punchout?.unix() - currentdts) + dts || "";
                newpunchin = data.punchin == "" ? "" : data?.punchin?.unix() || "";
                newpunchout = data.punchout == "" ? "" : data?.punchout?.unix() || "";

                let values = {
                    "type": data.type,
                    "username": userid,
                    "date": data.date.format("YYYY/MM/DD"),
                    "dts": dts,
                    "punchin": newpunchin,
                    "punchout": newpunchout,
                    "branchin": data.branchin == "" ? "" : data?.branchin,
                    "branchout": data.branchout == "" ? "" : data?.branchout,
                    "status": data.status,
                    "remark": data.remark,
                    "hours": data.hours,
                    "sections": data.sections
                }

                return createAttendance(values)
                    .then(val => {
                        if (val.status == "err") {
                            throw val.msg;
                        }
                        onRefresh({ searchuser: searchUser });
                        setIsModalVisible(false);
                        setcurrentuser("")
                        message.success(val.msg);
                    })
                    .catch(err => {
                        form.resetFields();
                        setIsModalVisible(false);
                        message.error(err);
                    });
            case "edit":
                dts = data.date.set({ "hour": 0, "minute": 0, "seconds": 0 }).unix();


                newpunchin = data.punchin == "" ? "" : data?.punchin?.unix() || "";
                newpunchout = data.punchout == "" ? "" : data?.punchout?.unix() || "";

                data.attendanceid = data._id;
                data.dts = dts;
                data.punchin = newpunchin;
                data.punchout = newpunchout;

                return updateAttendance(data)
                    .then(val => {
                        onRefresh({ searchuser: searchUser });
                        setIsModalVisible(false);
                        setcurrentuser("")
                        message.success(val.msg);
                    })
            default:
                message.error("unknown operation, check your interface and try again");
                setIsModalVisible(false);
                return;
        }
    }

    //====== ON USER SEARCH ======
    const onSearchUser = (user) => {

        // let tempuserid = user

        // if(tempuserid != undefined)
        // {
        //     if(tempuserid.length > 0)
        //     {
        //         tempuserid = userLists.filter(x => x.userid == user)[0]._id;

        //     }
        // }

        let tempdata = Fulldatasource.filter(x => x.key == user)

        // console.log("tempdata >>>",tempdata)
        // console.log("user >>>",user)
        // console.log("Fulldatasource >>>",Fulldatasource)
        if (tempdata.length == 0 || tempdata == undefined) {


            tempdata = Fulldatasource.filter(x => x.username == user)
        }
        setDatasource(tempdata)

        // setSearchUser(tempuserid);
        // onRefresh({ searchuser: tempuserid })

    }

    //===== STATUS CHANGE ======
    const onStatusChange = (stat) => {
        setStatus(stat);
        //===== IF STATUS IS "FORGET TO PUNCH IN" =====
        if (stat == "fpin") {
            //===== ATT TYPE CAN SELECT ====
            form.setFieldsValue({
                type: "Att"
            });
            setshowintime(false);
            setshowbranch(false);
        }
        else {
            form.setFieldsValue({
                type: ""
            });
            setshowintime(true);
            setshowbranch(true);
        }
    }

    //====== TYPE CHANGE =======
    const onTypeChange = (type) => {
        setType(type);
        if (type == "Att" || type == "WFH") {
            setshowintime(false);
            setshowbranch(false);
        }
        else {
            setshowintime(true);
            setshowbranch(true);
        }
    }

    //======= LIST ========
    const renderAttendanceItem = (item) => {
        let tempuserid = item.username
        let tempshift = ''
        let shifttype = ''

        if (tempuserid != undefined) {
            if (tempuserid.length > 0) {
                tempuserid = userLists.filter(x => x._id == item.username)[0];
                if (tempuserid != undefined) {
                    tempuserid = tempuserid.userid
                    tempshift = userLists.filter(x => x._id == item.username)[0].shift;

                    shifttype = shiftlist.filter(x => x._id == tempshift)[0] ? shiftlist.filter(x => x._id == tempshift)[0].worktype : ""


                }
                else {
                    tempuserid = item.username
                    tempshift = userLists.filter(x => x.userid == item.username)[0].shift;

                    shifttype = shiftlist.filter(x => x._id == tempshift)[0] ? shiftlist.filter(x => x._id == tempshift)[0].worktype : ""

                }
            }
        }

        return (
            <List.Item>
                <List.Item.Meta
                    avatar={
                        <Avatar src="https://zos.alipayobjects.com/rmsportal/ODTLcjxAfvqbxHnVXCYX.png" />
                    }
                    title={<>
                        <div style={{ color: item.isearly == 1 ? "green" : item.islate == 1 ? "red" : "" }}>
                            {tempuserid}  - {item.type}
                        </div>
                    </>}
                    description={

                        shifttype == 'flexible' ?
                            <>
                                <div style={{ color: item.missingpunchout == 1 ? "red" : "" }}>
                                    <div>
                                        Work        :   {convertSecondsToTime(item.workdurationperday)}
                                    </div>
                                    <div>
                                        Extra        :   {convertSecondsToTime(item.extraperday)}
                                    </div>
                                </div>


                            </>
                            :
                            <>

                                <div style={{ color: item.isearly == 1 ? "green" : item.islate == 1 ? "red" : "" }}>
                                    In      : {`${typeof item.punchin == "string" ? item.punchin == "" ? "" : moment.unix(item.punchin).format("DD/MM HH:mm") : item.punchin.format("DD/MM HH:mm")} at ${item.bipin == "" || item.bipin == undefined ? item.branchin : item.bipin}`}
                                </div>
                                <div>
                                    Out      : {`${typeof item.punchout == "string" ? item.punchout == "" ? "" : moment.unix(item.punchout).format("DD/MM HH:mm") : item.punchout.format("DD/MM HH:mm")} at ${item.bipout == "" || item.bipout == undefined ? item.branchout : item.bipout}`}
                                </div>
                            </>


                    }

                />
                <div>
                    <Button onClick={() => {

                        if (shifttype == "flexible") {

                            console.log("item.details >>>", item.details)
                            // ID IS NOT EXIST MEANS NOT PUNCH CARD

                            setcurrentuser(item)
                            setflexibledata(item.details)
                            setIsModalVisible2(true);


                        }
                        else {
                            let values = item;
                            let editId = values._id || "";
                            values.date = moment(item.date);
                            values.punchin = typeof item.punchin == "string" ? item.punchin == "" ? "" : moment.unix(item.punchin) : item.punchin;
                            values.punchout = typeof item.punchout == "string" ? item.punchout == "" ? "" : moment.unix(item.punchout) : item.punchout;
                            console.log("item >>>>", item)
                            form.setFieldsValue(values);
                            setType(values.type);

                            // ID IS NOT EXIST MEANS NOT PUNCH CARD

                            if (editId == "") {
                                showModal("create");
                            }
                            else {
                                showModal("edit");
                            }
                        }


                    }}>Edit</Button>
                </div>
            </List.Item>
        )
    }

    //===== DATE PICKER CONTROL =====
    // const disabledDate = (current) => {
    //     // Can not select days before today and today
    //     return current > moment().endOf('day');
    // }

    //======== FORM  ============
    const onAttendanceMgmtForm = () => {
        return (
            <>
                <Row justify="start">
                    <Divider>{prop.title ?? "."}</Divider>
                </Row>
                {/* HEADER */}
                {/* BODY */}
                <Row>
                    <Col span={24}>
                        <div style={{ float: "right" }}>
                            <Space size={2}>
                                {/* <Button onClick={() => { showModal("create")}}><PlusOutlined /></Button> */}
                                <Button onClick={onReload}>{btndisable ? <Spin /> : <ReloadOutlined />}</Button>
                            </Space>
                        </div>

                    </Col>
                </Row>
                {onFilterForm()}
                <Divider />
                <Row gutter={[8, 8]}>
                    <Col xs={24}>
                        <List {...listProps}></List>
                    </Col>
                </Row>
            </>
        )
    }

    const onAttendanceProfForm = () => {
        const formItemLayout = {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 6 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 14 },
            },
        };

        return (
            <Form form={form} onFinish={onFinish} >
                {
                    <>
                        {/* ID */}
                        <Form.Item name={"_id"} style={{ display: "none" }}></Form.Item>
                        {/* USER */}
                        <Form.Item
                            name={"username"}
                            label="Username"
                            rules={[{ required: true, message: "User is required" }]}
                            {...formItemLayout}
                        >
                            <Select placeholder={"Select User"} showSearch allowClear disabled={action == "edit" ? true : false}>
                                {
                                    userLists.map(function (data) {
                                        return (
                                            <Option value={data.userid}>{data.userid}</Option>
                                        )
                                    })
                                }
                            </Select>
                        </Form.Item>
                        {/* TYPE */}
                        <Form.Item
                            name={"type"}
                            label="Type"
                            rules={[{ required: true, message: "Type is required" }]}
                            {...formItemLayout}
                        >
                            <Select
                                placeholder={"Select Type"} showSearch allowClear onChange={onTypeChange} >
                                {leavetypes.map(leave => {
                                    if (leave != "Att") {
                                        return (
                                            <Option value={leave}>{leave}</Option>
                                        )
                                    }
                                    else {
                                        //==== if status is forget to punch in or action is create =====
                                        if (action == "create" || status == "fpin") {
                                            return (
                                                <Option value={leave}>{leave}</Option>
                                            )
                                        }
                                    }
                                })}
                            </Select>
                        </Form.Item>
                        <Form.Item
                            name={"date"}
                            label="Date"
                            rules={[{ required: true, message: "Date is required" }]}
                            {...formItemLayout}
                        >
                            <DatePicker {...formdateprops}></DatePicker>
                        </Form.Item>
                        {
                            type == "Free" ?

                                <>
                                    <Form.Item
                                        name={"hours"}
                                        label="Hour"
                                        rules={[{ required: true, message: "Hours is required" }]}
                                        {...formItemLayout}
                                    >
                                        <InputNumber min={1} max={12}/>
                                    </Form.Item>
                                </>
                                :
                                ['MC', 'AL', 'UL', 'EL', 'Trip','HL'].includes(type) ?
                                <>
                                <>
                                    <Form.Item
                                        name={"sections"}
                                        label="Sections"
                                        rules={[{ required: true, message: "Sections is required" }]}
                                        {...formItemLayout}
                                    >
                                       <Select
                                placeholder={"Full / Half"} showSearch allowClear >
                                     <Option value={'full'}>{'Full'}</Option>
                                     <Option value={'half'}>{"Half"}</Option>
                                    </Select>
                                    </Form.Item>
                                </>
                                </>
                                :
                                <>
                                    {/* IN ATTENDANCE */}
                                    <Form.Item
                                        name={"punchin"}
                                        label="In"
                                        rules={[{ required: false, message: "Punchin is required" }]}
                                        {...formItemLayout}
                                    >
                                        <DatePicker showTime {...formindateprops} />
                                        {/* <TimePicker {...formindateprops} /> */}
                                    </Form.Item>
                                    <Form.Item
                                        name={"branchin"}
                                        label="Branch In"
                                        rules={[{ required: false, message: "Branch In is required" }]}
                                        {...formItemLayout}
                                    >
                                        <Select disabled={showbranch}>
                                            {branchLists.map(function (data) {
                                                return (
                                                    <Option value={data.name}>{data.name}</Option>
                                                )
                                            })}
                                        </Select>
                                    </Form.Item>
                                    {/* OUT ATTENDANCE */}
                                    <Form.Item
                                        name={"punchout"}
                                        label="Out"
                                        rules={[{ required: false, message: "Punchout is required" }]}
                                        {...formItemLayout}
                                    >
                                        <DatePicker showTime {...formoutdateprops} />
                                    </Form.Item>
                                    <Form.Item
                                        name={"branchout"}
                                        label="Branch Out"
                                        rules={[{ required: false, message: "Branch Out is required" }]}
                                        {...formItemLayout}
                                    >
                                        <Select disabled={showbranch}>
                                            {branchLists.map(function (data) {
                                                return (
                                                    <Option value={data.name}>{data.name}</Option>
                                                )
                                            })}
                                        </Select>
                                    </Form.Item>
                                    {/* STATUS */}
                                    <Form.Item
                                        name={"status"}
                                        label="Status"
                                        rules={[{ required: false, message: "Status is required" }]}
                                        {...formItemLayout}
                                    >
                                        <Select placeholder={"Select Status"} allowClear onChange={onStatusChange}>
                                            <Option value={"pcl"}>Permission To Come In Late</Option>
                                            {/* <Option value={"fp"}>Forget To Punch out</Option> */}
                                            <Option value={"fpin"} style={{ display: form.getFieldsValue().type == "Att" ? "none" : "" }}>Forget To Punch In</Option>
                                        </Select>
                                    </Form.Item></>
                        }

                        {/* REMARK */}
                        <Form.Item
                            name={"remark"}
                            label="Remark"
                            rules={[{ required: false, message: "Remark is required" }]}
                            {...formItemLayout}
                        >
                            <TextArea autoSize={{ minRows: 3, maxRows: 5 }} />
                        </Form.Item>
                    </>
                }
            </Form>
        )
    }



    const onFilterForm = () => {
        return (
            <>
                <Row gutter={[8, 8]}>
                    <Col span={8}>
                        <div style={{ display: "inline", marginRight: "10px" }}>
                            Filter By:
                        </div>
                        <Select style={{ width: "100px" }} value={dateFilter} onChange={setDateFilter}>
                            <Option value={"date"}>Date</Option>
                            {/* <Option value={"month"}>Month</Option> */}
                        </Select>
                    </Col>
                </Row>
                <Row gutter={[8, 8]}>
                    {/* SELECT DATE */}
                    <Col span={6}>
                        <DatePicker {...dateprops}></DatePicker>
                    </Col>
                    <Col span={6}>
                        <Select {...leaveSelectprops} >
                            {leavetypes.map(leave => {
                                return (
                                    <Option value={leave}>{leave}</Option>
                                )
                            })}
                        </Select>
                    </Col>
                    <Col span={6}>
                        <Select style={{ width: "100%" }} placeholder={"Search User"} onChange={onSearchUser} allowClear showSearch>
                            {
                                userLists.map(function (data) {
                                    return (
                                        <Option value={data.userid}>{data.userid}</Option>
                                    )
                                })}
                        </Select>
                    </Col>
                    <Col span={6}>
                        <Select style={{ width: "100%" }} disabled>
                            <Option value={"oldest"}>Oldest</Option>
                            <Option value={"newest"}>Newest</Option>
                        </Select>
                    </Col>
                </Row>
                {(() => {
                    //====== SHOW TOTAL IF ONLY FOR DATE =======
                    if (dateFilter == "date") {
                        return (
                            <>
                                <Divider />
                                <Descriptions bordered size={"small"} layout={"vertical"}>
                                    <Descriptions.Item label="Total User">{totaluser}</Descriptions.Item>
                                    <Descriptions.Item label="User had taken attendance">{usertaken}</Descriptions.Item>
                                    <Descriptions.Item label="User had not take attendance">{userleft}</Descriptions.Item>
                                </Descriptions>
                            </>
                        )
                    }
                })()}
            </>
        )
    }

    //===== MODAL ======
    const onAttendanceModal = () => {
        return (
            <Modal
                title={modalTitle}
                visible={isModalVisible}
                destroyOnClose={true}
                style={{ maxWidth: "80%" }}
                bodyStyle={{ overflow: "auto", maxHeight: "70vh" }}
                onOk={handleOk}
                onCancel={handleCancel}
                okText="Submit"
            >
                {onAttendanceProfForm()}
            </Modal>
        )
    }

    const onFlexibleForm = () => {
        return (
            <>
                <Table dataSource={flexibledata} columns={flexibletable} />
            </>
        )
    }

    const onFlexibleModal = () => {
        return (
            <Modal
                title={"Records"}
                visible={isModalVisible2}
                destroyOnClose={true}
                style={{ maxWidth: "80%" }}
                bodyStyle={{ overflow: "auto", maxHeight: "70vh" }}
                onCancel={(e) => setIsModalVisible2(false)}
                footer={
                    <>
                        <Button key="create" onClick={(e) => handleflexiblecreate(currentuser)}>
                            Create
                        </Button>

                        <Button key="back" onClick={(e) => setIsModalVisible2(false)}>
                            Return
                        </Button>
                    </>

                }
            >
                {onFlexibleForm()}
            </Modal>
        )
    }

    const showModal = (modalAction) => {
        // setModalAction(modalAction);
        switch (modalAction) {
            case "create":
                setAction("create");
                setModalTitle(`New Attendance`);
                setshowintime(false);
                setIsModalVisible(true);
                break;
            case "edit":
                setAction("edit");
                setModalTitle("Edit Attendance");
                setshowintime(false);
                setIsModalVisible(true);
                break;
            default:
                message.error("No Action required");
                break;
        }
    };

    const handleflexiblecreate = (item) => {

        console.log("e items >>>", item)
        setIsModalVisible2(false)
        let values = { ...item };
        let editId = "";
        values.date = moment(values.date);
        values.punchin = "";
        values.punchout = "";

        form.setFieldsValue(values);
        //setType(values.type);

        // ID IS NOT EXIST MEANS NOT PUNCH CARD


        showModal("create");



    }

    const handleOk = () => {
        form.submit();
    }

    const handleCancel = () => {
        form.resetFields()
        setAction("")
        setType("");

        //=== modal set cannot edit ===
        setshowintime(true);
        setshowbranch(true);
        setIsModalVisible(false);
    }

    //======== PROPS ========
    const dateprops = {
        style: { width: "100%" },
        onChange: (date) => {
            setDate(date);
        },
        value: date,
        // disabledDate : disabledDate,
        picker: dateFilter == "date" ? "date" : "month"
    }

    const formdateprops = {
        disabled: true
        // disabledDate    : disabledDate,
        // disabled        : action == "edit" ? true : false
    }

    const formindateprops = {
        disabled: showintime
    }

    const formoutdateprops = {
        // disabledDate    : (current) => { return current <= moment().startOf('day').subtract(1, "day")},
        // disabled        : type == "MC" || type == "EL" || type == "Leave" ? true : false 
        disabled: showintime
        //disabled: parseInt(process.env.REACT_APP_SUPERADMIN) == 0 ? false : true
    }

    const leaveSelectprops = {
        style: { width: "100%" },
        allowClear: true,
        value: leavetypefilter,
        placeholder: "Leave Type",
        onChange: setleavetypefilter
    }

    const listProps = {
        dataSource: datasource,
        loading: initLoading,
        itemLayout: "horizontal",
        renderItem: renderAttendanceItem
    }

    return (
        <>
            {(() => {
                if (isMaintenance) {
                    return (<T_Error />)
                }
                else {
                    return (
                        <>
                            {onAttendanceMgmtForm()}
                            {onAttendanceModal()}
                            {onFlexibleModal()}
                        </>
                    )
                }
            })()}
        </>
    )
}